import { Pipe, PipeTransform } from '@angular/core';
/*
 * Transform the database field name to a readable labely
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | label-or-title
 * Example:
 *   {{ profilename | label-or-title }}
 *   formats to: Profile
*/
@Pipe({name: 'label-or-title'})
export class LabelTitlePipe implements PipeTransform {
  transform(value: string): string {
    var retstr = "";
    if(value == null || value == "")
    {
      retstr = "";
    }
    else if(value.toLocaleLowerCase() == 'accessgranted')
    {
      retstr = "Visible";
    }
    else if(value.toLocaleLowerCase() == 'profilename')
    {
      retstr = "Profile";
    }
    else
    {
      retstr = value;
    }

    return retstr;
  }
}